import { PropsWithChildren } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { OnboardingRoutes } from '@/config/routes';
import { useAuth } from '@/context/AuthProvider';

import ResetSplitMuiPage from '@/components/auth/ResetSplitMuiPage';

// import AuthSideContent from './AuthSideContent';

export interface AuthRouteState {
  from?: Location;
}

const ResetPageWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user) {
    // Extract campaign from query parameters to preserve it during redirect
    const urlParams = new URLSearchParams(location.search);
    const campaign = urlParams.get('campaign');

    // Create onboarding URL with campaign parameter if present
    const onboardingUrl = campaign
      ? `${OnboardingRoutes.index}?campaign=${campaign}`
      : OnboardingRoutes.index;

    return <Redirect to={onboardingUrl} />;
  }

  return <ResetSplitMuiPage>{children}</ResetSplitMuiPage>;
};

export default ResetPageWrapper;
